import {defineStore} from 'pinia'
import {ref} from 'vue'
import ICPSDK from '@/lib/ICPSDK_ALL.js'
import {registerICPEvents} from "@/services/registerEvents";

export const useICPStore = defineStore('icp', () => {
    const eventData = ref('');
    const config = {
        serverWSPort: '8002',
        serverAddress: 'sdkserver.cloudicp.huawei.com',
        serverHttpPort: '8002',
        debugMode: 'true',
        mediaType: '2',
        ringFlag: '0',
        mspVersion: '2.0',
        sdkStatusNotify(data) {
            eventData.value = data;
            console.log('SDK Status Notify:', data);
        },
    };

    const ICP = new ICPSDK(config);
    registerICPEvents(ICP);

    return {ICP, eventData};
});